/* File: src\components\replay\ReplayControls.js */

// src/components/replay/ReplayControls.js
import React from 'react';
// Removed unused AudioManager import
// import audioManager from '../../utils/audioManager'; // No longer needed here

/**
 * Modern ReplayControls Component
 * Provides playback controls for the replay viewer with step forward/backward.
 */
const ReplayControls = ({
    state,          // 'playing', 'paused', 'finished'
    currentTime,    // Current time in ms
    totalDuration,  // Total duration in ms
    speed,
    onPlayPause,
    onSpeedChange,
    onReset,
    onStepBackward, // New prop
    onStepForward,   // New prop
    difficultySeed, // Prop remains in signature even if not directly used for rendering
    defaultVoiceId  // Prop remains in signature even if not directly used for rendering
}) => {
    const speeds = [0.25, 0.5, 1.0, 1.5, 2.0];

    // Determine if stepping is possible (e.g., not at the very start/end)
    // These are just for disabling the buttons visually, the core logic is in ReplayViewer
    const canStepBackward = currentTime > 0;
    const canStepForward = currentTime < totalDuration;

    return (
        // --- START: MODIFIED Main Container ---
        // Changed to flex-row, justify-between to place buttons left, speed right
        // Removed sm:flex-row (always row now)
        // Adjusted gap
        <div className="flex flex-row items-center justify-between gap-2 w-full">
        {/* --- END: MODIFIED Main Container --- */}

            {/* Main Controls Button Group */}
            {/* Removed w-full sm:w-auto, let flexbox size it */}
            <div className="flex items-center gap-1 sm:gap-2"> {/* Reduced gap slightly for smaller screens */}
                {/* Reset Button */}
                <button
                    onClick={onReset}
                    className="bg-white text-gray-700 rounded-full border border-gray-300 hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-indigo-500 disabled:opacity-50 flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10" // Slightly smaller on mobile
                    title="Reset to Beginning"
                    aria-label="Reset replay"
                >
                    <i className="fas fa-rotate-left text-base sm:text-lg"></i> {/* Slightly smaller icon */}
                </button>

                {/* Step Backward Button */}
                <button
                    onClick={onStepBackward}
                    className="bg-white text-gray-700 rounded-full border border-gray-300 hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-indigo-500 disabled:opacity-50 flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10" // Slightly smaller on mobile
                    title="Step Backward"
                    disabled={!canStepBackward || state === 'playing'}
                    aria-label="Step backward one trial"
                >
                    <i className="fas fa-backward-step text-base sm:text-lg"></i> {/* Slightly smaller icon */}
                </button>

                {/* Play/Pause Button */}
                <button
                    onClick={onPlayPause}
                    className="bg-indigo-600 text-white rounded-full hover:bg-indigo-700 transition-colors shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-indigo-500 flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12" // Slightly smaller on mobile
                    title={state === 'playing' ? 'Pause' : (state === 'finished' ? 'Replay' : 'Play')}
                    aria-label={state === 'playing' ? 'Pause replay' : (state === 'finished' ? 'Replay session' : 'Play replay')}
                >
                    {/* Adjusted padding/size slightly */}
                    <i className={`fas ${state === 'playing' ? 'fa-pause' : 'fa-play'} text-lg sm:text-xl ${state !== 'playing' ? 'pl-0.5 sm:pl-1' : ''}`}></i>
                </button>

                {/* Step Forward Button */}
                <button
                    onClick={onStepForward}
                    className="bg-white text-gray-700 rounded-full border border-gray-300 hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-indigo-500 disabled:opacity-50 flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10" // Slightly smaller on mobile
                    title="Step Forward"
                    disabled={!canStepForward || state === 'playing'}
                    aria-label="Step forward one trial"
                >
                    <i className="fas fa-forward-step text-base sm:text-lg"></i> {/* Slightly smaller icon */}
                </button>
            </div>

            {/* Speed Control */}
            {/* Removed ml-auto as justify-between handles positioning */}
            <div className="flex items-center gap-1 sm:gap-2"> {/* Reduced gap slightly */}
                <label htmlFor="speedControl" className="text-xs sm:text-sm font-medium text-gray-700 hidden xs:block"> {/* Hide label on very small screens */}
                    Speed:
                </label>
                <select
                    id="speedControl"
                    value={speed}
                    onChange={(e) => onSpeedChange(e.target.value)}
                    // Slightly smaller padding/text on mobile
                    className="bg-white border border-gray-300 rounded-md px-2 py-1 sm:px-3 sm:py-1.5 text-xs sm:text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 disabled:bg-gray-100 disabled:text-gray-500"
                    disabled={state === 'playing'} // Disable speed change while playing
                    aria-label="Playback speed"
                >
                    {speeds.map(s => (
                        <option key={s} value={s}>{s}x</option>
                    ))}
                </select>
            </div>
            {/* Removed the empty <>/<React.Fragment> pair */}
        </div>
    );
};

export default ReplayControls;